module.exports = __webpack_public_path__ + "img/27.38aecc35.png";